import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Heading3, StackView, Text } from 'localmed-core';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { DiButton } from '../../../../../shared/components/DiComponents';
import { DiFailure } from '../../../../../shared/components/DiLayout';
import Calendar from '../../../../assets/Calendar-fill.gif';
import { IStepProps } from '../schedulingWizard';
import { Wrapper } from '../styles';

interface Props extends IStepProps {
  redirect?: boolean;
}

const Image = styled('img')`
  height: 250px;
`;

export default function SchedulingProgressStep({ wizard }: Props) {
  useEffect(() => {
    if (wizard) {
      wizard.formProps.handleSubmit();
      if (wizard.formProps.values.trackSchedulingEvent) {
        wizard.formProps.values.trackSchedulingEvent(
          'Scheduling In Progress',
          'SchedulingProgressStep'
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const errors = wizard?.formProps.values.appointmentMutationResponse?.errors;
  const submissionErrorMessage = wizard?.formProps.values.submissionErrorMessage;
  const status = wizard?.formProps.values.appointmentMutationResponse?.status;
  const hasServerError = wizard?.formProps.values.hasServerError;

  useEffect(() => {
    if (wizard && errors) {
      if (wizard.formProps.values.trackSchedulingEvent) {
        wizard.formProps.values.trackSchedulingEvent(
          'Appointment Scheduling Error',
          'SchedulingProgressStep',
          {
            errors,
            status,
          }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors, status]);

  if (!wizard) return null;

  if ((errors && !wizard.formProps.isSubmitting) || submissionErrorMessage || hasServerError) {
    return (
      <Wrapper justifyContent="center" alignItems="center">
        <DiFailure title="Ooops we ran into a problem scheduling your appointment.">
          <Text>
            <FormattedMessage
              id="scheduling.SchedulingPage.PageNotFoundMessage"
              defaultMessage="{hasSubmissionErrorMessage, select, true {{submissionErrorMessage}} false {Click the retry button but if the problem continues to happen give us a call at {phoneNumber} and we will get you taken care of.}} "
              values={{
                phoneNumber: wizard.formProps.values.office?.phone,
                hasSubmissionErrorMessage: !!submissionErrorMessage,
                submissionErrorMessage,
              }}
            />
          </Text>
          <DiButton onClick={() => wizard.formProps.handleSubmit()} size="xl" mt="xl">
            Retry
          </DiButton>
        </DiFailure>
      </Wrapper>
    );
  }

  return (
    <Wrapper justifyContent="center" alignItems="center">
      <StackView
        spacing="md"
        css={css`
          text-align: center;
        `}
      >
        <Image src={Calendar} alt="Di logo animation" />
        <Heading3>
          <FormattedMessage
            id="scheduling.SchedulingProgressStep.bookingInProgressMessage"
            defaultMessage="Booking your appointment…"
          />
        </Heading3>
      </StackView>
    </Wrapper>
  );
}
